// subs
import { subscribe } from "../emitter-subscriber/subscribe";
import { eventDetails } from "../event-details/event-details";
// rum
import { rumSend } from "../rum/rum-event";
// config
import { getConfig } from "../config/config-store";
// utils
import { getKey } from "../utils/key";
import { merge } from "../array.utils";
import { parsePayload } from "../utils/parse";
import { domModAttr } from "../utils/dom";
// event handlers
import { handleClick } from "../element-handlers/click";
import { handleMouseEnter, handleMouseLeave } from "../element-handlers/hover";
// types
import { elementAttributes } from "../types/element-attributes";
import { eventTypes } from "../types/event-types";
// elements
let elements;
const createElementEvents = () => {
    const stripAttributes = (elements) => {
        elements.forEach((element) => domModAttr(element, elementAttributes.track));
    };
    const attachEvent = (elements) => {
        elements.forEach((element) => {
            element.addEventListener("click", handleClick, false);
            element.addEventListener("mouseenter", handleMouseEnter, false);
            element.addEventListener("mouseleave", handleMouseLeave, false);
        });
    };
    const processElementEvent = (payload, domEvent) => {
        // console.log("processing element", payload);
        let { action } = payload;
        const storeConfig = getConfig(getKey(payload));
        // console.log("parsed", parsePayload(payload));
        const parsedPayload = storeConfig
            ? Object.assign(Object.assign(Object.assign({}, merge(parsePayload(payload), storeConfig)), (action && { action })), { event: domEvent }) : Object.assign(Object.assign(Object.assign({}, parsePayload(payload)), (action && { action })), { event: domEvent });
        rumSend(eventDetails(parsedPayload, eventTypes.journeyRecord));
    };
    const trackElementsSubscription = () => {
        subscribe("AAT_OBSERVE_ELEMENT_PASSIVE", () => {
            elements = document.querySelectorAll(`[${elementAttributes.track}]`);
            attachEvent(elements);
            stripAttributes(elements);
            elements = null; // clear elements
        });
    };
    return {
        trackElementsSubscription,
        processElementEvent,
        stripAttributes,
        attachEvent,
    };
};
export const { trackElementsSubscription, processElementEvent, stripAttributes, } = createElementEvents();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/element.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/element.js
// module chunks = 0